"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.setBluetoothConnectionStatus = exports.setBluetoothPairingState = exports.setBluetoothScanningState = exports.communicationSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const initialState = {
    bluetooth: {
        scanningState: null,
        pairingState: null,
        connected: false
    },
    error: undefined
};
exports.communicationSlice = (0, toolkit_1.createSlice)({
    name: 'communication',
    initialState,
    reducers: {
        setBluetoothScanningState: (state, action) => {
            state.bluetooth.scanningState = action.payload;
        },
        setBluetoothPairingState: (state, action) => {
            state.bluetooth.pairingState = action.payload;
        },
        setBluetoothConnectionStatus: (state, action) => {
            state.bluetooth.connected = action.payload;
        }
    }
});
_a = exports.communicationSlice.actions, exports.setBluetoothScanningState = _a.setBluetoothScanningState, exports.setBluetoothPairingState = _a.setBluetoothPairingState, exports.setBluetoothConnectionStatus = _a.setBluetoothConnectionStatus;
exports.default = exports.communicationSlice.reducer;
